import http from './http';

export async function listEvaluations(params) {
  const { data } = await http.get('/evaluations', { params });
  return data;
}

export async function createEvaluation(payload) {
  const { data } = await http.post('/evaluations', payload);
  return data;
}

export async function updateEvaluation(id, payload) {
  const { data } = await http.put(`/evaluations/${id}`, payload);
  return data;
}

export async function deleteEvaluation(id) {
  await http.delete(`/evaluations/${id}`);
}
